import { render, staticRenderFns } from "./MissionSuzukaIcon.vue?vue&type=template&id=3cf2a1c2&scoped=true"
import script from "./MissionSuzukaIcon.vue?vue&type=script&lang=js"
export * from "./MissionSuzukaIcon.vue?vue&type=script&lang=js"
import style0 from "./MissionSuzukaIcon.vue?vue&type=style&index=0&id=3cf2a1c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf2a1c2",
  null
  
)

export default component.exports